import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Row } from "react-bootstrap";
import { MdHotel } from "react-icons/md";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

const formatDate = (dateStr) => {
  const date = new Date(dateStr);
  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const months = [
    "Jan","Feb","Mar","Apr","May","Jun",
    "Jul","Aug","Sep","Oct","Nov","Dec",
  ];
  return `${String(date.getDate()).padStart(2, "0")} ${
    months[date.getMonth()]
  } ${date.getFullYear()}`;
};

const RecentHotelSearch = ({ cacheData }) => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // detect screen resize
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ⭐ HOTEL VERSION OF SEARCH CLICK
  const handleSearchClick = (item) => {
    const queryParams = new URLSearchParams({
      from: item.from || "",
      city: item.city || "",
      startDate: item.startDate || "",
      endDate: item.endDate || "",
      rooms: JSON.stringify(item.rooms || []),
    }).toString();

    navigate(`/hotelmodify?${queryParams}`);
  };

  const itemsToShow = isMobile ? 15 : 6;

  return (
    <>
      {cacheData.length > 0 && (
        <div className="flightBookingMainDiv">
          <h4 className="tripgo_title_recent hotel_recent_search">Recent Hotel Search</h4>

          <Row>
            {/* 📱 Mobile View */}
            {isMobile ? (
              <Swiper slidesPerView={3} spaceBetween={5} className="recentSearchSwiper">
                {cacheData.slice(0, itemsToShow).map((item, index) => (
                  <SwiperSlide key={index}>
                    <div
                      className="FlightBookingDel hotelBookingDel_recent"
                      onClick={() => handleSearchClick(item)}
                      style={{
                        cursor: "pointer",
                        border: "1px solid #ddd",
                        borderRadius: "8px",
                        padding: "10px",
                        background: "#fff",
                      }}
                    >
                      <div className="flightBookingtext">
  <MdHotel style={{ marginRight: "5px" }} />
  {item.city?.length > 8 ? item.city.slice(0, 8) + "..." : item.city}
</div>

                      <div className="flightBookingMinText">
                        {formatDate(item.startDate)} → {formatDate(item.endDate)}
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            ) : (
              // 💻 Desktop View
              <div className="flightBookingSearch_recent">
                {cacheData.slice(0, itemsToShow).map((item, index) => (
                  <div
                    className="FlightBookingDel hotelBookingDel"
                    key={index}
                    onClick={() => handleSearchClick(item)}
                    style={{ cursor: "pointer" }}
                  >
                      <div className="flightBookingtext">
  <MdHotel style={{ marginRight: "5px" }} />
  {item.city?.length > 16 ? item.city.slice(0, 16) + "..." : item.city}
</div>

                    <div className="flightBookingMinText">
                      {formatDate(item.startDate)} → {formatDate(item.endDate)}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </Row>
        </div>
      )}
    </>
  );
};

export default RecentHotelSearch;
